import {useEffect, useState} from "react";
import moment from "moment";

import VLFModal from "@/components/Modal";
import VLFDatePicker from "@/components/Input/DatePicker";
import VLFSelectNew from "@/components/Input/SelectNew";
import VLFTextField from "@/components/Input/TextField";

import {paymentMethodOptions} from "@/utils/constants";

function HandleInstallmentModal(props) {
	const {open, close, confirm, installment} = props;

	const [formData, setFormData] = useState({});

	useEffect(() => {
		if (installment) {
			setFormData({
				paidDate: moment().format("YYYY-MM-DD"),
				paymentMethod: null,
				amount: installment.amount,
				notes: "",
			});
		}
	}, [installment]);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	return (
		<VLFModal
			maxWidth="sm"
			open={open}
			title="Segna rata come pagata"
			close={close}
			confirm={() => {
				confirm({
					paidDate: formData.paidDate,
					paymentMethod: formData.paymentMethod?.value || null,
					amount: parseFloat(formData.amount) || installment?.amount,
					notes: formData.notes || "",
				});
			}}
			content={
				<div className="row">
					<div className="col-12 mb-3">
						<div className="sec-note sec-note--box">
							Rata in scadenza:{" "}
							{installment?.dueDate
								? moment(installment.dueDate).format("DD/MM/YYYY")
								: "—"}
							{" · "}
							Importo:{" "}
							{installment?.amount
								? `${parseFloat(installment.amount).toLocaleString("it-IT")}€`
								: "—"}
						</div>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFDatePicker
							label="Data pagamento"
							value={formData.paidDate || null}
							onChange={(value) => {
								setFormData({...formData, paidDate: value});
							}}
							size="small"
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFSelectNew
							options={paymentMethodOptions}
							sorted={false}
							isClearable
							value={formData.paymentMethod || ""}
							onChange={(value) => {
								setFormData({...formData, paymentMethod: value});
							}}
							label="Metodo pagamento"
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="amount"
							value={formData.amount || ""}
							onChange={(e) => {
								setFormData({...formData, amount: e.target.value});
							}}
							label="Importo effettivo (€)"
							size="small"
							type="number"
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="notes"
							value={formData.notes || ""}
							onChange={(e) => {
								setFormData({...formData, notes: e.target.value});
							}}
							label="Note"
							size="small"
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandleInstallmentModal;
